import CryptoJS from 'crypto-js';

export const idleTimer = () => {
    let t;
    // // window.onload = resetTimer;
    window.onmousemove = resetTimer; // catches mouse movements
    window.onmousedown = resetTimer; // catches mouse movements
    window.onclick = resetTimer;     // catches mouse clicks
    window.onscroll = resetTimer;    // catches scrolling
    window.onkeypress = resetTimer;  //catches keyboard actions

    // //  function logout() {
    //     // window.location.href = '/action/logout';  //Adapt to actual logout script
    //     console.log('logout triggered')
    // }

    function reload() {
        window.location = window.location.href;  //Reloads the current page
    }

    function resetTimer() {
        clearTimeout(t);
        // t = setTimeout(logout, 5000);  // time is in milliseconds (1000 is 1 second)
        t = setTimeout(reload, 1800000);  // time is in milliseconds (1000 is 1 second) 30 min timer
    }
}

export const generateClientSeed = () => {
    // Generate a 16-byte random value
    const seedArray = new Uint8Array(16);
    window.crypto.getRandomValues(seedArray);

    // Convert the random bytes to a hexadecimal string
    const seed = Array.from(seedArray)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');

    // Hash the seed using SHA-256
    const seedHash = CryptoJS.SHA256(seed).toString(CryptoJS.enc.Hex);

    return { seed, seedHash };
};